export type CharacterProps = {
  src: string;
  className: string;
};

/** Absolute-positioned welcome character image (animation via className CSS). */
export function Character({ src, className }: CharacterProps) {
  return <img className={className} src={src} alt="" draggable={false} />;
}
